var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocketLaunch } from '@fortawesome/pro-regular-svg-icons/faRocketLaunch';
import { Spacer } from '../../components/base';
import { Button } from '@appspotr/ui-kit';
import { TopBarButtonWrapper } from './styles';
import { Popover } from 'react-tiny-popover';
import PublishPopOverBody from './PublishPopOverBody';
var PublishPopOver = function (_a) {
    var isVisiblePublishPopOver = _a.isVisiblePublishPopOver, setIsVisiblePublishPopOver = _a.setIsVisiblePublishPopOver, handleDownloadModalOpen = _a.handleDownloadModalOpen, handleNewVersionModalOpen = _a.handleNewVersionModalOpen, closeSharePopOver = _a.closeSharePopOver;
    return (_jsx(Popover, __assign({ isOpen: isVisiblePublishPopOver, positions: ['bottom'], align: "end", content: _jsx(PublishPopOverBody, { handleDownloadModalOpen: handleDownloadModalOpen, handleNewVersionModalOpen: handleNewVersionModalOpen }), onClickOutside: function () { return setIsVisiblePublishPopOver(false); } }, { children: _jsx(TopBarButtonWrapper, { children: _jsxs(Button, __assign({ style: {
                    backgroundColor: '#7f4aff',
                    border: '1px solid #7f4aff',
                    color: '#ffffff',
                }, onClick: function () {
                    setIsVisiblePublishPopOver(!isVisiblePublishPopOver);
                    closeSharePopOver();
                } }, { children: [_jsx(FontAwesomeIcon, { color: "#ffffff", icon: faRocketLaunch }), _jsx(Spacer, { type: "narrow" }), "Publish"] })) }) })));
};
export default PublishPopOver;
